module.exports = __webpack_public_path__ + "img/eg-4.692efbf0.png";